import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useChildProfile } from "../contexts/ChildProfileContext";
import { Card } from "../design/BigButton";
import { BigButton } from "../design/BigButton";
import { Lock } from "lucide-react";

export function WorldMapScreen() {
  const { profileId } = useParams();
  const navigate = useNavigate();
  const { selected } = useChildProfile();
  const [worlds, setWorlds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get("/worlds").then(({ data }) => {
      if (!cancelled) {
        setWorlds(data.items || []);
        setLoading(false);
      }
    });
    return () => (cancelled = true);
  }, []);

  const totalStars = selected?.totalStars || 0;

  return (
    <div className="wmleye-app world-map" data-testid="world-map">
      <header className="world-map__header">
        <BigButton variant="ghost" onClick={() => navigate(`/child/${profileId}/home`)} data-testid="world-map-back">
          ← Home
        </BigButton>
        <h1>Pick a world</h1>
        <div className="world-map__stars" data-testid="world-map-stars">⭐ {totalStars}</div>
      </header>
      {loading ? (
        <p>Loading…</p>
      ) : (
        <div className="world-map__ribbon" role="list">
          {worlds.map((w) => {
            const locked = totalStars < (w.requiredStars || 0);
            return (
              <button
                key={w.id}
                className={`world-card${locked ? " world-card--locked" : ""}`}
                onClick={() => !locked && navigate(`/child/${profileId}/worlds/${w.slug}`)}
                disabled={locked}
                data-testid={`world-card-${w.slug}`}
                aria-label={`${w.name}${locked ? `, locked — need ${w.requiredStars} stars` : ""}`}
              >
                <div
                  className="world-card__thumb"
                  style={{ backgroundImage: `url(${w.thumbnailUrl})` }}
                >
                  {locked && (
                    <div className="world-card__lock" aria-hidden>
                      <Lock size={40} />
                    </div>
                  )}
                </div>
                <div className="world-card__body">
                  <h3>{w.name}</h3>
                  {locked ? (
                    <p className="world-card__hint">
                      Earn {w.requiredStars - totalStars} more star
                      {w.requiredStars - totalStars === 1 ? "" : "s"} to unlock this world!
                    </p>
                  ) : (
                    <p>{w.description}</p>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
